import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanActivateChild, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { CryptoJsService } from 'src/app/services/crypto-js.service';

@Injectable({
  providedIn: 'root'
})
export class DepartmentGuardGuard implements CanActivateChild {
  
  constructor(
    private router: Router,
    private cryptoJsService: CryptoJsService
  ) { }

  canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const encDataD = sessionStorage.getItem('dataD') ? JSON.parse(this.cryptoJsService.DecryptSessionD(sessionStorage.getItem('dataD'))) : null;
    const loginDetails = new Map(encDataD);
    const isDeptLogin = loginDetails.get('isDepartment') ? loginDetails.get('isDepartment') : null;
    const isDDEWLogin = loginDetails.get('isDDEW') ? loginDetails.get('isDDEW') : null;

    if (isDeptLogin === '1' || isDDEWLogin === '1') {
      return true;
    } else {
      this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
      return false;
    }
  }

}
